export default __webpack_public_path__ + "static/node_runner_tablet-4580d1208ff26036310d2d143d3e51e6.png";